import {serializeDate} from "../../util/date-utils"

export interface IInsightApi {
  getMonthlySpending(dateFrom?: Date, dateUntil?: Date, signal?: AbortSignal): Promise<MonthlySpendingData>
}

export class InsightApi implements IInsightApi {
  constructor(private baseUrl: string) {
  }

  async getMonthlySpending(dateFrom?: Date, dateUntil?: Date, signal?: AbortSignal): Promise<MonthlySpendingData> {
    const buffer = []
    if (dateFrom) buffer.push("from=" + serializeDate(dateFrom))
    if (dateUntil) buffer.push("until=" + serializeDate(dateUntil))
    const datePart = (buffer.length > 0) ? "?" + buffer.join("&") : ""
    const url = this.baseUrl + "/monthlyspending" + datePart

    const response = await fetch(url, {method: "get", signal, credentials: "include"})
    const monthlySpendingData = await response.json()

    // convert dates
    if (monthlySpendingData.from) monthlySpendingData.from = new Date(monthlySpendingData.from)
    if (monthlySpendingData.until) monthlySpendingData.until = new Date(monthlySpendingData.until)

    return monthlySpendingData
  }
}

export interface MonthlySpendingData {
  months: MonthWithIndex[]
  spendingByMonthByCategory: Record<number, Record<number, number>>
  co2ByMonthByCategory: Record<number, Record<number, number>>
  from?: Date
  until?: Date
}

export interface MonthWithIndex {
  month: string
  index: number
}